module.exports = __webpack_public_path__ + "img/norway-cardiovascular-diseases-male.59a62509.png";